function createDeepCopy(data) {
  return JSON.parse(JSON.stringify(data))
}

export default createDeepCopy
